import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, openContent, Show, TS_Checkbox, TS_PropRenderer, TS_Tabs, TS_Toggle } from '@nu-art/thunderstorm-frontend/index';
import { newAdvisorWizardStep, ViewDataLabelMap } from '@app/advisor-content-shared';
import { EditorHeader_AdvisorContext } from './EditorHeader_AdvisorContext.js';
import './Editor_AdvisorWizard.scss';
import { SearchableItem_AdvisorWizard } from '../consts.js';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText, DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
import { ICONS } from '@app/styles';
import { DropDown_Variable, ModuleFE_ContextRule, ModuleFE_Tag, ModuleFE_Variable, Q_SortableList, QScrollWrapper } from '@app/hcs-frontend';
import { _keys, arrayIncludesAny, cloneObj, sortArray } from '@nu-art/ts-common';
import { DropDown_AdvisorSnippet } from '../../../_entity/snippet/ui-components.js';
import { ModuleFE_AdvisorSnippet } from '../../../_entity/snippet/index.js';
import { advisorWizardConfig_InfoMap, advisorWizardConfig_LabelMap } from '@app/advisor-content-shared/_enum/index';
const infoTooltipId = 'tooltip__advisor-wizard-info';
export class Editor_AdvisorWizard extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        if (nextProps.editMode !== undefined) {
            state.editMode = nextProps.editMode;
        }
        else {
            state.editMode ??= false;
            if (!state.editable.item._id)
                state.editMode = true;
        }
        //Auto set selected step if changed wizard
        if (state.editable.item._id !== this.state?.editable.item._id) {
            //Only set if there are steps
            if (!state.editable.item.steps?.length)
                state.selectedStep = undefined;
            else {
                const steps = state.editable.editProp('steps', []);
                state.selectedStep = steps.editProp(0, {});
                state.selectedStep.stepIndex = 0;
            }
        }
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? 'edit' : 'normal';
    getItemActions = () => {
        const actions = [];
        if (!this.state.editMode)
            actions.push({
                label: 'Edit Wizard',
                action: async () => this.setState({ editMode: true }),
            });
        actions.push({
            label: 'Delete Wizard',
            action: async () => {
                await this.state.editable.delete();
                this.props.deselectWizard?.();
            }
        });
        return actions;
    };
    getEditModeActions = () => {
        const actions = [];
        //Actions for existing wizard
        if (this.state.editable.item._id)
            actions.push({
                label: 'Done',
                action: async () => this.setState({ editMode: false }),
            });
        //Actions for new wizard
        else {
            if (this.props.deselectWizard)
                actions.push({
                    label: 'Cancel',
                    action: async () => {
                        return this.props.deselectWizard();
                    },
                });
            actions.push({
                label: 'Save',
                action: async () => {
                    await this.state.editable.save();
                },
            });
        }
        return actions;
    };
    onStepSelected = (index) => {
        const steps = this.state.editable.editProp('steps', []);
        const selectedStep = steps.editProp(index, {});
        selectedStep.stepIndex = index;
        this.setState({ selectedStep });
    };
    getTagIdsForStep = (step) => {
        const snippets = ModuleFE_AdvisorSnippet.cache.filter(snippet => !!step.item.snippets?.find(item => item.snippetId === snippet._id));
        const contextRules = ModuleFE_ContextRule.cache.filter(rule => !!snippets.find(snippet => snippet.contextRuleId === rule._id));
        return contextRules.map(contextRule => contextRule._tagIds).flat();
    };
    getTabs = () => {
        const dataKeys = ['searchData', 'freeTextData', 'formData',];
        return dataKeys.map(key => {
            return {
                uid: key,
                title: () => _jsx(_Fragment, { children: ViewDataLabelMap[key] }),
                content: () => this.renderTabContent(key)
            };
        });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { id: 'editor__advisor-wizard', children: [!this.props.hideHeader && this.renderHeader(), this.renderBody()] });
    }
    renderHeader = () => {
        return _jsx(EditorHeader_AdvisorContext, { editMode: this.state.editMode, editable: this.state.editable, searchableItem: SearchableItem_AdvisorWizard, itemActions: this.getItemActions(), editModeActions: this.getEditModeActions() });
    };
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'editor__advisor-wizard__body', children: [_jsxs(LL_V_L, { className: 'editor__advisor-wizard__body__left', children: [_jsxs(LL_V_L, { className: 'editor__advisor-wizard__details', children: [this.renderWizardLabel(), this.renderWizardRenderedLabel(), this.renderWizardConfig()] }), this.renderStepsList()] }), this.renderStepEditor()] });
    };
    // ######################## Render - Body ########################
    renderWizardLabel = () => {
        const wizard = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: 'normal',
                        renderer: () => _jsx("div", { className: 'editor__advisor-wizard__body__value', children: wizard.item.label })
                    },
                    {
                        key: 'edit',
                        renderer: () => _jsx(DefaultEditor_InputText, { editable: wizard, prop: 'label', saveEvent: ['blur'] })
                    },
                ] }) });
    };
    renderWizardConfig = () => {
        const wizard = this.state.editable;
        const editable = wizard.editProp('config', {});
        const configKeys = _keys(advisorWizardConfig_LabelMap);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Config', children: configKeys.map(key => {
                const checked = !!editable.item[key];
                return _jsxs(LL_H_C, { className: 'editor__advisor-wizard__config', children: [_jsx("div", { className: 'editor__advisor-wizard__config__label', children: advisorWizardConfig_LabelMap[key] }), _jsx(ICONS.information.component, { ...openContent.tooltip.top('editor__advisor-wizard__config-tooltip', advisorWizardConfig_InfoMap[key], { offset: 10 }) }), _jsx(TS_Toggle, { checked: !!editable.item[key], onCheck: () => {
                                editable.updateObj({ [key]: !checked });
                            }, disabled: !this.state.editMode })] }, key);
            }) });
    };
    renderWizardRenderedLabel = () => {
        const wizard = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Rendered Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: 'normal',
                        renderer: () => _jsx("div", { className: 'editor__advisor-wizard__body__value', children: wizard.item.renderedLabel ?? 'N/A' })
                    },
                    {
                        key: 'edit',
                        renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: wizard, prop: 'renderedLabel', saveEvent: ['blur'] })
                    },
                ] }) });
    };
    renderStepsList = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: this.renderStepsLabel, className: 'editor__advisor-wizard__steps-section', children: this.renderStepsItems() });
    };
    renderStepsLabel = () => {
        return _jsxs(LL_H_C, { className: 'editor__advisor-wizard__steps-header', children: [_jsx("span", { children: "Steps" }), this.state.editMode && _jsx(ICONS.advisor_v5_plus.component, { className: 'steps-add-icon', onClick: () => {
                        const steps = this.state.editable.editProp('steps', []);
                        return steps.updateArrayAt(cloneObj(newAdvisorWizardStep));
                    } })] });
    };
    renderStepsItems = () => {
        const steps = this.state.editable.editProp('steps', []);
        return _jsx(Q_SortableList, { className: 'editor__advisor-wizard__step-list', disabled: this.getViewMode() !== 'edit', items: steps.item ?? [], itemRenderer: (step, index) => {
                const className = _className('editor__advisor-wizard__body__step', index === this.state.selectedStep?.stepIndex && 'selected');
                return _jsx(LL_H_C, { className: className, onClick: () => this.onStepSelected(index), children: _jsxs(Show, { children: [_jsx(Show.If, { condition: true, children: _jsx("div", { className: 'editor__advisor-wizard__body__step__label', children: step.label }) }), _jsx(Show.If, { condition: step.formData.isActive, children: _jsx(ICONS.advisor_v4_form.component, { ...openContent.tooltip.top(infoTooltipId, 'Step can be rendered as a form', { offset: 5 }) }) }), _jsx(Show.If, { condition: step.freeTextData.isActive, children: _jsx(ICONS.advisor_v4_editor.component, { ...openContent.tooltip.top(infoTooltipId, 'Step can be rendered as a free text box', { offset: 5 }) }) }), _jsx(Show.If, { condition: step.searchData.isActive, children: _jsx(ICONS.advisor_v4_search.component, { ...openContent.tooltip.top(infoTooltipId, 'Step can be rendered as a search form', { offset: 5 }) }) }), _jsx(Show.If, { condition: this.state.editMode, children: _jsx(ICONS.bin.component, { onClick: () => {
                                        return steps.removeArrayItem(index);
                                    } }) })] }) }, index);
            }, onChange: stepList => {
                this.state.editable.updateObj({ steps: stepList });
            } });
    };
    // ######################## Render - Step Editor ########################
    renderStepEditor = () => {
        if (!this.state.selectedStep)
            return;
        return _jsxs(LL_V_L, { className: 'editor__advisor-wizard__body__step-editor', children: [this.renderStepEditor_Label(this.state.selectedStep), this.renderStepEditor_ViewModes()] });
    };
    renderStepEditor_Label = (step) => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: 'normal',
                        renderer: () => _jsx("div", { className: 'editor__advisor-wizard__body__value', children: step.item.label })
                    },
                    { key: 'edit', renderer: () => _jsx(DefaultEditor_InputText, { editable: step, prop: 'label' }) },
                ] }) });
    };
    renderStepEditor_ViewModes = () => {
        const tabs = this.getTabs();
        return _jsx(TS_Tabs, { className: 'editor__advisor-wizard__view-modes', tabs: tabs });
    };
    renderTabContent = (key) => {
        const selectedStep = this.state.selectedStep;
        if (!selectedStep)
            return;
        const editable = selectedStep.editProp(key, {});
        return _jsxs(_Fragment, { children: [_jsxs(LL_H_C, { style: { gap: '20px' }, children: [this.renderStepEditor_ViewMode_Active(editable), this.renderStepEditor_ViewMode_OverwriteSnippets(editable)] }), _jsxs(LL_H_C, { className: 'editor__advisor-wizard__view-modes__content', children: [this.renderStepEditor_ViewMode_Snippets(editable.item.overwriteSnippets ? editable : selectedStep), this.renderStepEditor_ViewMode_Tags(editable.item.overwriteSnippets ? editable : selectedStep), this.renderStepEditor_ViewMode_Variables(editable.item.overwriteSnippets ? editable : selectedStep)] })] });
    };
    renderStepEditor_ViewMode_Active = (editable) => {
        const isActive = editable.item.isActive;
        const editMode = this.getViewMode() === 'edit';
        return _jsx(TS_Checkbox, { disabled: !editMode, checked: isActive, onCheck: () => editable.updateObj({ isActive: !isActive }), children: "Is Active" });
    };
    renderStepEditor_ViewMode_OverwriteSnippets = (editable) => {
        const overwrite = editable.item.overwriteSnippets;
        const editMode = this.getViewMode() === 'edit';
        return _jsx(TS_Checkbox, { disabled: !editMode, checked: overwrite, onCheck: () => editable.updateObj({ overwriteSnippets: !overwrite }), children: "Overwrite Snippets" });
    };
    renderStepEditor_ViewMode_Snippets = (editable) => {
        const snippets = editable.editProp('snippets', []);
        const editMode = this.getViewMode() === 'edit';
        const existingSnippetIds = editable.item.snippets?.map(i => i.snippetId);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Snippets', children: _jsxs(LL_V_L, { className: 'editor__snippet-list', children: [_jsx(Q_SortableList, { disabled: !editMode, items: snippets.item ?? [], itemRenderer: (item, index) => {
                            const editableSnippet = snippets.editProp(index, {})
                                .setOnDelete(async () => snippets.removeArrayItem(index));
                            return this.render_Editor_StepSnippet(editableSnippet);
                        }, onChange: items => {
                            return editable.updateObj({ snippets: items });
                        } }), editMode && _jsx(DropDown_AdvisorSnippet.selectable, { selected: undefined, placeholder: 'Add Snippet', queryFilter: snippet => !existingSnippetIds?.includes(snippet._id), onSelected: snippet => {
                            return snippets.updateArrayAt({ snippetId: snippet._id });
                        } })] }) });
    };
    render_Editor_StepSnippet = (editable) => {
        const snippet = ModuleFE_AdvisorSnippet.cache.unique(editable.item.snippetId);
        const editMode = this.getViewMode() === 'edit';
        return _jsxs(LL_H_C, { className: 'editor__snippet-list__snippet', children: [snippet?.label ?? 'N/A', _jsx(DropDown_Variable, { canUnselect: true, disabled: !editMode, selected: editable.item.resolvedVariableId, onSelected: variable => {
                        editable.updateObj({ resolvedVariableId: variable?._id });
                    } }), editMode && _jsx(ICONS.bin.component, { onClick: () => editable.delete() })] });
    };
    renderStepEditor_ViewMode_Tags = (editable) => {
        const tagIds = this.getTagIdsForStep(editable);
        const tags = ModuleFE_Tag.cache.filter(tag => tagIds.includes(tag._id));
        sortArray(tags, tag => tag.label.toLowerCase());
        const label = () => {
            return _jsxs(_Fragment, { children: ["Tags ", _jsx(ICONS.information.component, { ...openContent.tooltip.top(infoTooltipId, 'Aggregation of tags under all snippets connected to this step', { offset: 5 }) })] });
        };
        return _jsx(TS_PropRenderer.Vertical, { label: label, children: _jsx(QScrollWrapper, { children: tags.map(tag => {
                    return _jsx("div", { children: tag.label }, tag._id);
                }) }) });
    };
    renderStepEditor_ViewMode_Variables = (editable) => {
        const tagIds = this.getTagIdsForStep(editable);
        const variables = ModuleFE_Variable.cache.filter(variable => arrayIncludesAny(tagIds, variable._tagIds));
        sortArray(variables, variable => variable.name.toLowerCase());
        const label = () => {
            return _jsxs(_Fragment, { children: ["Variables ", _jsx(ICONS.information.component, { ...openContent.tooltip.top(infoTooltipId, 'Aggregation of variables under all snippets connected to this step', { offset: 5 }) })] });
        };
        return _jsx(TS_PropRenderer.Vertical, { label: label, children: _jsx(QScrollWrapper, { children: variables.map(variable => {
                    return _jsx("div", { children: variable.name }, variable._id);
                }) }) });
    };
}
//# sourceMappingURL=Editor_AdvisorWizard.js.map